import React, {useState, useEffect, useMemo} from 'react'
import {
  ParagraphText,
  // Icon
} from '@thryvlabs/maverick'
import {
  commandCenterIcon,
  marketingCenterIcon,
  reportingCenterIcon,
  workforceCenterIcon,
  businessCenterIcon,
  keapMaxIcon,
} from '../assets'
import {formatPrice} from '../utils/currency-format'
import {useSelector} from 'react-redux'

const DEFAULT_CART_ITEMS = [
  {
    name: 'my account',
    icon: commandCenterIcon,
  },
  {
    name: 'business center',
    icon: businessCenterIcon,
  },
  {
    name: 'marketing center',
    icon: marketingCenterIcon,
  },
  {
    name: 'reporting center',
    icon: reportingCenterIcon,
  },
  {
    name: 'workforce center',
    icon: workforceCenterIcon,
  },
  {
    name: 'keap max',
    icon: keapMaxIcon,
  },
]
const ONE_TIME_ADDONS = ['thryvprfee', 'thryvdesg2', 'keap-ignite-thryvprfee']
const NON_ADDED_PLANS = ['addon-5-signatures_usage', 'app-websitebuilder']

export const KCPPaymentDetails = ({
  paymentState,
  paymentDetailType = 'monthly',
  cartDetailObj,
  taxAmount = -1,
  finalBillingAmountDetails,
  currentScreen,
  couponList = [],
  previewDetails = {},
  preselectedSubData = null,
}) => {
  const [oneTimeFeeAmount, setOneTimeFeeAmount] = useState(0)
  const [subList, setSubList] = useState([])
  const {isMobileViewEnable} = useSelector(state => state.screenView)
  console.log({isMobileViewEnable})
  const pTagItemStyle = {
    'font-family': 'Open Sans',
    'font-weight': 400,
    'font-style': 'Regular',
    'font-size': '16px',
    'leading-trim': 'NONE',
    'line-height': isMobileViewEnable ? '0px' : '30px',
    'letter-spacing': '0px',
    verticalAlign: 'center',
    margin: '0px',
    color: '#121212',
  }

  const totalDuePTagStyle = {
    'font-family': 'Open Sans',
    'font-weight': '600',
    'font-style': 'SemiBold',
    'font-size': isMobileViewEnable ? '16px' : '20px',
    'leading-trim': 'NONE',
    'line-height': isMobileViewEnable ? '0xp' : '44px',
    'letter-spacing': '0px',
    color: 'black',
    margin: '0px',
  }

  const overAllDeduction = useMemo(() => {
    // Only skip deduction calculation if we have actual preview data with totals
    if (
      finalBillingAmountDetails?.total ||
      (previewDetails?.paymentPreview &&
        previewDetails.paymentPreview.total !== undefined)
    ) {
      return 0
    }

    let totalDeduction = 0
    let addOns =
      cartDetailObj?.productSub?.childSubscriptions
        ?.filter(childSub => childSub.addons && childSub.addons.length > 0)
        ?.map(filteredChildSub => filteredChildSub.addons)
        ?.flat() || []
    let oneTimeFees = cartDetailObj?.productSub?.oneTimeFees || []

    let cartItems = [...addOns, ...oneTimeFees]
    cartItems = cartItems?.map(item => item.code) || []

    let cartPlans =
      cartDetailObj?.plans?.filter(
        plan => !cartItems.find(item => item === plan.code),
      ) || []
    cartPlans = cartPlans?.map(plan => plan.code) || []

    if (couponList.length > 0 && cartDetailObj) {
      cartDetailObj?.plans.forEach(product => {
        console.log('processing product ', product)
        let productDiscount = 0
        couponList.forEach(coupon => {
          console.log('checking coupon ', coupon)
          let couponDiscount = 0
          const isApplicable =
            (coupon.appliesToAllPlans && cartPlans.includes(product.code)) ||
            (coupon.appliesToAllItems && cartItems.includes(product.code)) ||
            (coupon.appliesToPlans &&
              coupon.appliesToPlans.includes(product.code)) ||
            (coupon.appliesToItems &&
              coupon.appliesToItems.includes(product.code))

          if (isApplicable) {
            console.log('coupon is applicable')
            if (coupon.type === 'fixed') {
              couponDiscount = coupon.discountAmount
            } else if (coupon.type === 'percent') {
              couponDiscount =
                (coupon.discountPercent *
                  product.unitAmount *
                  product.quantity) /
                100
            }
            console.log('coupon discount calculated as ', couponDiscount)
          }

          if (couponDiscount > productDiscount) {
            productDiscount = couponDiscount
          }
        })
        console.log('product discount ::', productDiscount)
        totalDeduction += productDiscount
        console.log('total discount ::', totalDeduction)
      })
    }

    return totalDeduction
  }, [
    couponList,
    cartDetailObj?.plans,
    finalBillingAmountDetails,
    previewDetails,
  ])

  useEffect(() => {
    let OTFDeduction = 0
    let data = cartDetailObj?.plans?.filter(item => {
      if (
        paymentDetailType === 'monthly' &&
        ONE_TIME_ADDONS.includes(item.code)
      ) {
        OTFDeduction = OTFDeduction + Number(item.unitAmount)
        return false
      }
      return true
    })
    data = data?.filter(item => !NON_ADDED_PLANS.includes(item.code))

    setSubList(data)
    setOneTimeFeeAmount(OTFDeduction)
  }, [cartDetailObj, cartDetailObj?.plans, paymentDetailType])

  const cartItemDetail = (item, isPreview = false) => {
    if (item?.isAlreadyAdded && paymentDetailType !== 'monthly') {
      return <></>
    }
    let isDiscountApplicable = false
    let imageObj = DEFAULT_CART_ITEMS.find(cartItem =>
      item?.name.toLowerCase().includes(cartItem?.name),
    )
    let appliesToSpecificPlan = couponList.filter(
      item => !item.appliesToAllPlans,
    )

    // Only show discount details if not in preview mode
    if (!isPreview) {
      if (item?.name === 'Onboarding Fee') {
        for (const coupon of couponList) {
          if (
            coupon?.appliesToPlans?.includes('onboarding-fee') ||
            coupon?.appliesToItems?.includes('thryvprfee')
          ) {
            isDiscountApplicable = true
          }
        }
      } else {
        for (const coupon of couponList) {
          if (coupon?.appliesToPlans?.includes(item.code)) {
            isDiscountApplicable = true
          }
        }
      }
    } else {
      if (item?.discount && item?.discount > 0) {
        isDiscountApplicable = true
      }
    }

    return (
      <div
        className="monthly_container"
        style={{marginTop: isMobileViewEnable ? '30px' : '12px'}}
        key={item?.name}
      >
        <div className="d-flex justify-content-between align-items-center">
          <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
            {imageObj && (
              <img
                style={{borderRadius: '5px'}}
                src={imageObj.icon}
                alt={item.name}
                height={`${isMobileViewEnable ? '20px' : '38px'}`}
                width={`${isMobileViewEnable ? '20px' : '38px'}`}
              />
            )}
            <p style={pTagItemStyle}>{item.name}</p>
          </div>
          <p style={pTagItemStyle}>
            {item?.subtotal
              ? formatPrice(item?.subtotal)
              : formatPrice((item?.unitAmount || 0) * (item?.quantity || 1))}
          </p>
        </div>

        {isDiscountApplicable && (
          <>
            <div className="d-flex mt-2 justify-content-between align-items-center">
              <div className="d-flex" style={{columnGap: '8px'}}>
                <ParagraphText
                  variant="reg"
                  className="m-0"
                  style={{
                    color: '#4D4D4D',
                    fontFamily:
                      'Open Sans, Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif',
                  }}
                >
                  {`Incentive`}
                </ParagraphText>
              </div>
              <ParagraphText
                variant="reg"
                className="m-0"
                style={{
                  color: '#4D4D4D',
                  fontFamily:
                    'Open Sans, Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif',
                }}
              >
                {item?.discount && item?.discount > 0
                  ? formatPrice(Number(item?.discount) * -1)
                  : formatPrice(getDiscountedAmount(item))}
              </ParagraphText>
            </div>
            <div className="d-flex mt-2 justify-content-between align-items-center">
              <div className="d-flex" style={{columnGap: '8px'}}>
                <ParagraphText
                  variant="reg"
                  className="m-0"
                  style={{
                    color: '#4D4D4D',
                    fontFamily:
                      'Open Sans, Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif',
                  }}
                >
                  {appliesToSpecificPlan.name}
                </ParagraphText>
              </div>
              <ParagraphText
                variant="reg"
                className="m-0"
                style={{
                  color: '#4D4D4D',
                  fontFamily:
                    'Open Sans, Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif',
                }}
              >
                {''}
              </ParagraphText>
            </div>
          </>
        )}
        {item?.name?.includes('Marketing') && item?.addons?.length > 0 && (
          <div className="mt-1">
            {item.addons.map(addonItem => (
              <div
                key={addonItem.name}
                className="d-flex justify-content-between align-items-center"
              >
                <div className="d-flex" style={{columnGap: '8px'}}>
                  <ParagraphText
                    variant="reg"
                    className="m-0"
                    style={{
                      color: '#4D4D4D',
                      fontFamily:
                        'Open Sans, Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif',
                    }}
                  >
                    {addonItem.name}
                  </ParagraphText>
                </div>
                <ParagraphText
                  variant="reg"
                  className="m-0"
                  style={{
                    color: '#4D4D4D',
                    fontFamily:
                      'Open Sans, Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif',
                  }}
                >
                  {formatPrice(
                    (addonItem?.unitAmount || 0) * (addonItem?.quantity || 1),
                  )}
                </ParagraphText>
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }

  const getDiscountedAmount = item => {
    let couponAmount = 0
    if (item?.name === 'Onboarding Fee') {
      for (const coupon of couponList) {
        if (
          coupon?.appliesToPlans?.includes('onboarding-fee') ||
          coupon?.appliesToItems?.includes('thryvprfee')
        ) {
          if (coupon.discountAmount > 0) couponAmount += coupon.discountAmount
          else if (coupon.discountPercent > 0)
            couponAmount +=
              (item.quantity || 1) *
              item.unitAmount *
              (coupon.discountPercent / 100)
        }
      }
    } else {
      for (const coupon of couponList) {
        if (coupon.appliesToPlans?.includes(item.code)) {
          if (coupon.discountAmount > 0) couponAmount += coupon.discountAmount
          else if (coupon.discountPercent > 0)
            couponAmount +=
              (item.quantity || 1) *
              item.unitAmount *
              (coupon.discountPercent / 100)
        }
      }
    }
    if (couponAmount > (item.quantity || 1) * item.unitAmount) {
      return (item.quantity || 1) * item.unitAmount * -1
    } else return couponAmount * -1
  }

  const calculateTax = () => {
    if (paymentDetailType === 'monthly') {
      return 'To be calculated'
    } else {
      if (finalBillingAmountDetails?.tax) {
        return formatPrice(finalBillingAmountDetails?.tax || 0)
      } else if (previewDetails?.paymentPreview) {
        return formatPrice(previewDetails?.paymentPreview?.tax || 0)
      } else {
        return 'To be calculated'
      }
    }
  }

  const calculateTotalAmount = () => {
    if (paymentDetailType === 'monthly') {
      const total = cartDetailObj?.totalAmount - oneTimeFeeAmount

      if (isNaN(total)) {
        return (
          <p>
            <span className="summary-cstm-spinner" />
          </p>
        )
      }

      return `${formatPrice(total)} + tax*`
    } else {
      if (finalBillingAmountDetails?.total) {
        let total = finalBillingAmountDetails?.total || 0
        if (isNaN(total)) {
          return (
            <p>
              <span className="summary-cstm-spinner" />
            </p>
          )
        }
        if (total < 0) {
          total = 0
        }
        return formatPrice(total)
      } else if (previewDetails?.paymentPreview) {
        let total = previewDetails?.paymentPreview?.total || 0

        if (isNaN(total)) {
          return (
            <p>
              <span className="summary-cstm-spinner" />
            </p>
          )
        }
        if (total < 0) {
          total = 0
        }
        return formatPrice(total)
      } else {
        // if (cartDetailObj?.upgradeOrder) {
        // Check if totalAmountToday already has discounts applied
        // If totalAmountToday differs from totalAmount, discount is already applied
        // const discountAlreadyApplied =
        //   cartDetailObj?.totalAmountToday !== cartDetailObj?.totalAmount
        // let total = discountAlreadyApplied
        //   ? cartDetailObj?.totalAmountToday
        //   : cartDetailObj?.totalAmountToday - overAllDeduction

        //   let total = cartDetailObj?.totalAmount - overAllDeduction
        //   if (isNaN(total)) {
        //     return (
        //       <p>
        //         <span className="summary-cstm-spinner" />
        //       </p>
        //     )
        //   }
        //   if (total < 0) {
        //     total = 0
        //   }
        //   return `${formatPrice(total)} + tax*`
        // }

        let totalAmountToday =
          cartDetailObj?.plans
            ?.map(item =>
              item?.isAlreadyAdded
                ? 0
                : item?.unitAmount * (item?.quantity || 1),
            )
            ?.reduce((acc, curr) => acc + curr) || 0

        let total = totalAmountToday - overAllDeduction

        if (isNaN(total)) {
          return (
            <p>
              <span className="summary-cstm-spinner" />
            </p>
          )
        }
        if (total < 0) {
          total = 0
        }
        return `${formatPrice(total)} + tax*`
      }
    }
  }
  const renderPlanDetails = subDetails => {
    let planDetails = [
      ...subDetails.apps,
      ...subDetails.centers,
      ...subDetails.oneTimes,
    ]

    return (
      <>
        {planDetails
          .sort(itemComparator)
          .map(item => cartItemDetail(item, true))}
      </>
    )
  }

  const rankItem = item => {
    const ranking = {
      'addon-socialadsbronze-5-m2m': 2,
      'addon-socialadssilver-5-m2m': 3,
      'addon-socialadsgold-5-m2m': 4,
    }

    const identifiers = [item.code, item.planCode, item.addonCode].filter(
      Boolean,
    )

    const matched = identifiers.find(id => ranking[id])

    return matched ? ranking[matched] : 1
  }

  const itemComparator = (a, b) => {
    const rankA = rankItem(a)
    const rankB = rankItem(b)
    return rankA - rankB
  }

  return (
    <div style={{backgroundColor: 'white'}}>
      {previewDetails?.paymentPreview ? (
        <>
          {isMobileViewEnable ? (
            <p
              style={{
                fontFamily: 'Open Sans',
                fontWeight: 600,
                fontStyle: 'SemiBold',
                fontSize: '20px',
                lineHeight: '0px',
                letterSpacing: 0,
                marginBottom: '32px',
                color: '#000000',
              }}
            >
              Due {paymentDetailType === 'monthly' ? 'Monthly' : 'Today'}
            </p>
          ) : (
            <h2
              style={{
                fontFamily: 'Open Sans',
                fontWeight: 600,
                fontStyle: 'SemiBold',
                fontSize: '20px',
                lineHeight: '44px',
                letterSpacing: 0,
                marginBottom: '12px',
                color: '#000000',
              }}
            >
              Due {paymentDetailType === 'monthly' ? 'Monthly' : 'Today'}
            </h2>
          )}

          {renderPlanDetails(previewDetails.paymentPreview)}
          {paymentDetailType === 'today' &&
            previewDetails.coupons &&
            previewDetails.coupons.length > 0 &&
            previewDetails.coupons.map(item => {
              return (
                <div className="monthly_container mt-2" key={item?.name}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex" style={{columnGap: '8px'}}>
                      <ParagraphText
                        variant="reg"
                        className="m-0"
                        style={{color: '#4D4D4D'}}
                      >
                        {item.name}
                      </ParagraphText>
                    </div>
                  </div>
                </div>
              )
            })}
          <div className={`${isMobileViewEnable ? 'mt-4' : 'mt-2'}`}>
            <div className="d-flex justify-content-between">
              <p style={pTagItemStyle}>Tax</p>
              <p style={pTagItemStyle}>{calculateTax()}</p>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignContent: 'center',
              'border-top': '1px solid #80808080',
              marginTop: '52px',
              paddingTop: '8px',
            }}
          >
            <p style={totalDuePTagStyle}>
              Total Due
              {` ${paymentDetailType === 'monthly' ? 'Monthly' : 'Today'}`}
            </p>

            <p style={totalDuePTagStyle}>{calculateTotalAmount()}</p>
          </div>
          <div className="d-flex justify-content-between">
            {paymentDetailType === 'monthly' && (
              <ParagraphText variant="sm" style={{opacity: '50%'}}>
                *Excludes taxes, fees, and incentives
              </ParagraphText>
            )}
          </div>
        </>
      ) : (
        <>
          {isMobileViewEnable ? (
            <p
              style={{
                fontFamily: 'Open Sans',
                fontWeight: 600,
                fontStyle: 'SemiBold',
                fontSize: '20px',
                lineHeight: '0px',
                letterSpacing: 0,
                marginBottom: '32px',
                color: '#000000',
              }}
            >
              Due {paymentDetailType === 'monthly' ? 'Monthly' : 'Today'}
            </p>
          ) : (
            <h2
              style={{
                fontFamily: 'Open Sans',
                fontWeight: 600,
                fontStyle: 'SemiBold',
                fontSize: '20px',
                lineHeight: '44px',
                letterSpacing: 0,
                marginBottom: '12px',
                color: '#000000',
              }}
            >
              Due {paymentDetailType === 'monthly' ? 'Monthly' : 'Today'}
            </h2>
          )}

          {subList &&
            subList.length > 0 &&
            subList.sort(itemComparator).map(item => cartItemDetail(item))}
          {paymentDetailType === 'today' &&
            couponList &&
            couponList.length > 0 &&
            couponList.map(item => {
              return (
                <div className="monthly_container mt-2" key={item?.name}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex" style={{columnGap: '8px'}}>
                      <ParagraphText
                        variant="reg"
                        className="m-0"
                        style={{color: '#4D4D4D'}}
                      >
                        {item.name}
                      </ParagraphText>
                    </div>
                  </div>
                </div>
              )
            })}
          <div className={`${isMobileViewEnable ? 'mt-4' : 'mt-2'}`}>
            <div className="d-flex justify-content-between">
              <p style={pTagItemStyle}>Tax</p>
              <p style={pTagItemStyle}>{calculateTax()}</p>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignContent: 'center',
              'border-top': '1px solid #80808080',
              marginTop: '52px',
              paddingTop: '8px',
            }}
          >
            <p style={totalDuePTagStyle}>
              Total Due
              {` ${paymentDetailType === 'monthly' ? 'Monthly' : 'Today'}`}
            </p>

            <p style={totalDuePTagStyle}>{calculateTotalAmount()}</p>
          </div>
          <div className="d-flex justify-content-between">
            {paymentDetailType === 'monthly' && (
              <ParagraphText variant="sm" style={{opacity: '50%'}}>
                *Excludes taxes, fees, and incentives
              </ParagraphText>
            )}
          </div>
        </>
      )}
    </div>
  )
}
